import { render, staticRenderFns } from "./LedesTypeForm.vue?vue&type=template&id=7b94ef6c&"
import script from "./LedesTypeForm.vue?vue&type=script&lang=js&"
export * from "./LedesTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LedesTypeForm.vue?vue&type=style&index=0&id=7b94ef6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports